import {Constants} from './accountConstants'
import {Account} from '../../../model/account.model'

export function addAccount(account: Account) {
	return {
		type: Constants.ADD_ACCOUNT,
		payload: account
	} as const
}

export function setAccounts(accounts: Account[]) {
	return {
		type: Constants.SET_ACCOUNTS,
		payload: accounts
	} as const
}

export function updateAccount(account: Account) {
	return {
		type: Constants.UPDATE_ACCOUNT,
		payload: account
	} as const
}

export function removeAccounts() {
	return {
		type: Constants.REMOVE_ACCOUNTS
	} as const
}